// extracted by mini-css-extract-plugin
module.exports = {"pageNavLink":"PageNavigationLink_pageNavLink__l1ykX","linkText":"PageNavigationLink_linkText__Yg7qd"};